import React, { useRef, useContext, useState } from "react";
import { Box, Typography, Input, InputLabel, Button } from "@mui/material";
import { FormControl } from "@mui/material";
import { ThemeModeContext, contentBoxStyle } from "../shared/Theme";
import { Link } from "react-router-dom";
import userService from "../services/userService";
import alertService from "../services/alertService";

const Forgot = () => {
	
	const [ emailSent, setEmailSent ] = useState(false);
	
	const themeModeContext = useContext(ThemeModeContext);
	const imageUrls = {
		"light": "/cymplify-logo_light.png",
		"dark": "/cymplify-logo_dark.png",
	}
	const imageUrl = imageUrls[themeModeContext.themeMode];
	
	const email = useRef(null);

	const handleSubmit = (e) => {
		e.preventDefault();
		
		let emailValue = (email.current)? email.current.value : null;
		
		if (emailValue.trim() === "") {
			return alertService.show(`Please enter an email address and try again`);
		}
		
		if (email.current) email.current.value = "";
		setEmailSent(true);
		
		userService.forgotPassword(emailValue)
		.catch((err) => {
			console.log(err.message);
			if (email.current) email.current.value = "";
		});
	};

	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	const inputStyle = {
		padding: "0 1em"
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Box sx={contentBoxStyle}>
					<Box sx={{
						height: "30em",
						width: "25em",
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)"
					}}>
						<Box sx={{ textAlign: "center" }}>
							<Link to="/">
								<img src={imageUrl} alt="cymplify logo" />
							</Link>
						</Box>
						{ emailSent &&
							<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
								<Typography>An email has been sent to the address provided if correct</Typography>
								<br/>
								<Link to="/" style={{textDecoration: "none", textAlign: "center"}}>
									<Typography sx={{color: "text.link"}}>Continue</Typography>
								</Link>
							</Box>
						}
						{ !emailSent &&
							<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
								<Typography>Please enter the email address associated with your account</Typography>
							</Box>
						}
						{ !emailSent &&
							<form onSubmit={handleSubmit}>
								<FormControl sx={formControlStyle}>
									<InputLabel htmlFor="email">Email</InputLabel>
									<Input inputRef={email} id="email" type="email" inputProps={{ sx: {inputStyle}}}/>
								</FormControl>
								<FormControl sx={formControlStyle}>
									<Button type="submit" label="Request Password Reset">Request Password Reset</Button>
								</FormControl>
							</form>
						}
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

export default Forgot;
